<template>
  <div class="row">
    <div class="col-lg-12">
<!--      <b-button @click="creat" class="btn btn-success">{{ $t("common.new") }}</b-button>-->
    </div>
    <div class="col-xl-12 col-lg-12 order-lg-3 order-xl-1">
      <table class="table table-bordered">
        <thead class="thead-light">
        <tr>
          <th class="text-left" rowspan="2">
            {{ $t("socialUsefulWork.list.name") }}
          </th>
          <th class="text-left" colspan="2">
            {{ $t("socialUsefulWork.list.shortDescription") }}
          </th>
          <th class="text-left" rowspan="2">
            {{ $t("socialUsefulWork.list.socUsefulWorkContent") }}
          </th>
          <th class="text-left" rowspan="2">
            
          </th>
        </tr>
        <tr>
          <th class="text-left">
            {{ $t("socialUsefulWork.list.socUsefulWorkFirstHalf") }}
          </th>
          <th class="text-left">
            {{ $t("socialUsefulWork.list.socUsefulWorkSecondHalf") }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.studentName }}</td>
          <td>{{ item.socUsefulWorkFirstHalf }}</td>
          <td>{{ item.socUsefulWorkSecondHalf }}</td>
          <td>{{ item.socUsefulWorkContent }}</td>
          <td>
            <b-button
                type="submit"
                @click="edit(item)"
                variant="primary"
            >
              {{ $t("common.edit") }}
            </b-button>
          </td>
        </tr>
        </tbody>
      </table>
      <div>
        <b-modal id="socialUsefulWork-modal" ref="socialUsefulWork-modal">
          <template v-slot:modal-title>
            {{ $t("common.new") }}
          </template>
          <b-form>
            <div>
              {{ $t("socialUsefulWork.list.name") }} - {{form.studentName}}
            </div>
            <b-form-group>
              <template v-slot:label>
                {{ $t("socialUsefulWork.list.socUsefulWorkFirstHalf") }}
              </template>
              <b-form-input
                  v-model="form.socUsefulWorkFirstHalf"
                  :state="modelState.socUsefulWorkFirstHalf"
              ></b-form-input>
              <div class="invalid-feedback">{{ modelSaveErrors.socUsefulWorkFirstHalf }}</div>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>
                {{ $t("socialUsefulWork.list.socUsefulWorkSecondHalf") }}
              </template>
              <b-form-input
                  v-model="form.socUsefulWorkSecondHalf"
                  :state="modelState.socUsefulWorkSecondHalf"
              ></b-form-input>
              <div class="invalid-feedback">{{ modelSaveErrors.socUsefulWorkSecondHalf }}</div>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>
                {{ $t("socialUsefulWork.list.socUsefulWorkContent") }}
              </template>
              <b-form-input
                  v-model="form.socUsefulWorkContent"
                  :state="modelState.socUsefulWorkContent"
              ></b-form-input>
              <div class="invalid-feedback">{{ modelSaveErrors.socUsefulWorkContent }}</div>
            </b-form-group>
          </b-form>          

          <template v-slot:modal-footer>
            <b-button type="submit" @click="onSubmit" variant="primary" id="save-subject-data-button">
              {{ $t("common.save") }}
            </b-button>
            <b-button type="reset" @click="onReset" variant="danger">
              {{ $t("common.cancel") }}
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
  name: "SocialUsefulWork",
  components: {
  },
  props:{
    groupId:String
  },
  data() {
    return {
      modalName: "socialUsefulWork-modal",
      items: [],
      form: {
        studentId: 0,
        studentName: "",
        socUsefulWorkFirstHalf: "",
        socUsefulWorkSecondHalf: "",
        socUsefulWorkContent: "",
      },
      modelState: {},
      modelSaveErrors: {}
    };
  },
  mounted() {    
    this.reloadData();
  },
  methods: {
    onSubmit(evt) {
      let submitButton = document.getElementById("save-subject-data-button");
      submitButton.classList.add("kt-spinner", "kt-spinner--light", "disabled");
      
      evt.preventDefault();
      let $this = this;
      this.form.groupId = this.groupId;

      ApiService.postSecured("journal/additional/saveSocialUsefulWork", this.form)
          .then(function () {
            $this.$refs[$this.modalName].hide();
            $this.reloadData();
            $this.cleanModel();
          })
          .catch(({response}) => {
            if (response.data != null && response.data.errors != null) {
              $this.modelSaveErrors = response.data.errors;

              for (let i in response.data.errors) {

                $this.modelState[i] = false;
              }
            }else{
              alert("Ошибка, перезайдите или обратитесь к администратору");
            }
          }).finally(function () {
            submitButton.classList.remove("kt-spinner", "kt-spinner--light", "disabled");
          });
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form = {};

      this.$refs[this.modalName].hide();
    },
    reloadData() {
      ApiService.querySecured("journal/additional/socialUsefulWork", {
        params: {groupId: this.groupId}
      }).then(({data}) => {
        this.items = data;
      }).catch(({response}) => {
        console.log(response);
      });
    },
    cleanModel() {
      this.form = {};
    },
    edit(item) {
      this.form = item;
      this.$refs[this.modalName].show();
    },
    creat(){
      this.form = {};
      this.$refs[this.modalName].show();
    }
  }
};
</script>
